import React from 'react'
import { Button, Dropdown, Menu } from 'antd'
import { DataTable } from './DataTable'
import { YhBox } from '@/components/YhBox'
import { DescriptionColorEnum, IDescription } from '@/components/YhBox/Types'
import useNavModel from '@/model/navModel'
import { globalPrompt } from '@/components/message'
import { YhAuth } from '@/components/auth/YhAuth'
import { useAssetsClearDetailsModel } from './details/assetsClearDetailsModel'
import { useAssetsClearModel } from '../assetsClearModel'
import { ResourceAuthEnum } from '@/types/AppResourceAuthEnum'
import { PlusOutlined } from '@ant-design/icons'

export const DataBox = () => {
    const { selectedRowKeys, statistics, exportData,setPrint,GetprintTip} = useAssetsClearModel()
    const { resetEditCatch } = useAssetsClearDetailsModel()
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => [])

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt('message', { text: '请选择单条数据进行编辑，点击鼠标右键可一键选中哦！', type: 'warning' })
            return
        }
        let AssetsClearEditKey = '2-7-2'
        let isFindNav = findNav(AssetsClearEditKey)
        if (!isFindNav) {
            addNav(AssetsClearEditKey, { id: selectedRowKeys[0] as string, mode: 'edit' })
            resetEditCatch()
        } else {
            globalPrompt('modal', {
                title: '物资清理跳转详情',
                type: 'warning',
                text: '您还有物资清理详情未保存，是否跳转',
                okText: '跳转未保存页',
                onOk: () => selectNav(isFindNav ? isFindNav.id : ''),
                cancelText: '打开新页签',
                onCancel: () => {
                    switchNavState(AssetsClearEditKey, { id: selectedRowKeys[0] as string, mode: 'edit' })
                    resetEditCatch()
                },
            })
        }
    }

    const action = (
        <>
        {/* <YhAuth resCode={ResourceAuthEnum.ASSETS_S_S_AD}> */}
            <Button className="mr-5" type="link" shape="round" onClick={() => addNav('2-7-1', { id: '', mode: 'add' })}>
            <PlusOutlined />
                清理
            </Button>
            {/* </YhAuth> */}
            <YhAuth resCode={ResourceAuthEnum.ASSETS_S_S_EX}>
            <Button className="mr-5" type="link" shape="round" onClick={() => exportData()}>
                导出
            </Button>
            </YhAuth>
            
            <div style={{ fontSize: '17px', fontWeight: 'bolder', float: 'right' }}>
                <span>
                    清理数量：<span style={{ color: 'green' }}>{statistics?.totalNum}</span>
                </span>
    
            </div>
        </>
    )

    return (
        <YhBox action={action}>
            <DataTable />
        </YhBox>
    )
}
